export default __webpack_public_path__ + "static/media/banner-convenio-tablet.05fe7f32.svg";